import {
  Configuration,
  ReportExportControllerApiFactory,
} from '@ce-openapi/reporting-service-ts-axios-client';
import { MOKA_GOAUTH_SERVICE } from '../constants';

const REPORTING_SERVICE = `${MOKA_GOAUTH_SERVICE}/reporting-revamp`;

const conf = new Configuration({
  basePath: REPORTING_SERVICE,
});

export const exportQuantitySummaryReport = (
  { startDate, endDate },
  outletIds
): Promise<any> =>
  ReportExportControllerApiFactory(conf)._export(
    outletIds.join(','),
    startDate,
    endDate,
    'itemBundleSalesReport',
    undefined,
    undefined,
    'items',
    { responseType: 'blob' }
  );

export const exportReportApi = (
  { startDate, endDate },
  outletIds,
  reportType,
  reportCategory
): Promise<any> =>
  ReportExportControllerApiFactory(conf)._export(
    outletIds,
    startDate,
    endDate,
    reportType,
    undefined,
    undefined,
    reportCategory,
    { responseType: 'blob' }
  );
